/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_Text_FieldInputs */

const en_admin_questionnaire_editor_text_field = /** @type {(inputs: Admin_Questionnaire_Editor_Text_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text field`)
};

const nl_admin_questionnaire_editor_text_field = /** @type {(inputs: Admin_Questionnaire_Editor_Text_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekstveld`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_Text_FieldInputs) => LocalizedString} */
const de_admin_questionnaire_editor_text_field = en_admin_questionnaire_editor_text_field;

/** @type {(inputs: Admin_Questionnaire_Editor_Text_FieldInputs) => LocalizedString} */
const es_admin_questionnaire_editor_text_field = en_admin_questionnaire_editor_text_field;

/** @type {(inputs: Admin_Questionnaire_Editor_Text_FieldInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_text_field = en_admin_questionnaire_editor_text_field;

/** @type {(inputs: Admin_Questionnaire_Editor_Text_FieldInputs) => LocalizedString} */
const it_admin_questionnaire_editor_text_field = en_admin_questionnaire_editor_text_field;

/** @type {(inputs: Admin_Questionnaire_Editor_Text_FieldInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_text_field = en_admin_questionnaire_editor_text_field;

/** @type {(inputs: Admin_Questionnaire_Editor_Text_FieldInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_text_field = en_admin_questionnaire_editor_text_field;

/** @type {(inputs: Admin_Questionnaire_Editor_Text_FieldInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_text_field = en_admin_questionnaire_editor_text_field;

/** @type {(inputs: Admin_Questionnaire_Editor_Text_FieldInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_text_field = en_admin_questionnaire_editor_text_field;

/**
* | output |
* | --- |
* | "Text field" |
*
* @param {Admin_Questionnaire_Editor_Text_FieldInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_text_field = /** @type {((inputs?: Admin_Questionnaire_Editor_Text_FieldInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_Text_FieldInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_text_field(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_text_field(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_text_field(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_text_field(inputs)
	if (locale === "nl") return nl_admin_questionnaire_editor_text_field(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_text_field(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_text_field(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_text_field(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_text_field(inputs)
	return ro_admin_questionnaire_editor_text_field(inputs)
});
export { admin_questionnaire_editor_text_field as "admin.questionnaire_editor.text_field" }